<template>
  <div class="news-detail-page">
    <AppHeader />

    <button class="detail-back" type="button" @click="goBack">返回</button>

    <div v-if="loading" class="detail-empty">加载中...</div>
    <div v-else-if="!article" class="detail-empty">资讯不存在或已下架</div>
    <template v-else>
      <header class="detail-top">
        <h1 class="detail-top__title">{{ article.title }}</h1>
        <div class="detail-top__meta">
          <span>{{ article.company }}</span>
          <span>{{ formatDate(article.publishTime) }}</span>
          <span>{{ article.region }}</span>
        </div>
      </header>

      <section class="detail-section">
        <template v-for="(block, idx) in contentFlow" :key="idx">
          <p v-if="block.type === 'text'" class="detail-paragraph">{{ block.text }}</p>
          <img
            v-else-if="block.type === 'image'"
            class="detail-image"
            :src="formatImg(block.url)"
            :alt="article.title"
          />
        </template>
      </section>
    </template>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import { getNewsArticleById } from '@/api/newsArticles'
import { formatImg } from '@/utils/formatImg'

export default {
  name: 'NewsDetail',
  components: { AppHeader, AppFooter },
  data() {
    return {
      loading: false,
      article: null
    }
  },
  computed: {
    contentFlow() {
      const raw = this.article?.content
      if (!raw) return []

      // 新格式：图文混排 JSON
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (Array.isArray(parsed) && parsed.length) {
          return parsed
            .map((item) => {
              if (item?.type === 'image' && item.url) {
                return { type: 'image', url: item.url }
              }
              if (item?.type === 'text' && item.text) {
                return { type: 'text', text: String(item.text).trim() }
              }
              return null
            })
            .filter(Boolean)
        }
      } catch (e) {
        // 兼容旧纯文本
      }

      // 旧格式回退：先文字段落，再 image_urls
      const paragraphs = String(raw)
        .split(/\n+/)
        .map((s) => s.trim())
        .filter(Boolean)
        .map((text) => ({ type: 'text', text }))

      let images = []
      try {
        const list = this.article?.imageUrls
          ? (typeof this.article.imageUrls === 'string'
            ? JSON.parse(this.article.imageUrls)
            : this.article.imageUrls)
          : []
        if (Array.isArray(list)) {
          images = list
            .filter((u) => typeof u === 'string' && u)
            .map((url) => ({ type: 'image', url }))
        }
      } catch (e) {
        images = []
      }

      return [...paragraphs, ...images]
    }
  },
  watch: {
    '$route.query.id': {
      immediate: true,
      handler() {
        this.loadDetail()
      }
    }
  },
  methods: {
    formatImg,
    formatDate(value) {
      if (!value) return ''
      return String(value).replace('T', ' ').slice(0, 16)
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ name: 'NewsCenter' })
      }
    },
    async loadDetail() {
      const id = this.$route.query.id
      if (!id) {
        this.article = null
        return
      }
      this.loading = true
      try {
        this.article = await getNewsArticleById(id)
      } catch (e) {
        console.error('加载资讯详情失败', e)
        this.article = null
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }
}
</script>

<style scoped>
@import url(../../style/news/news-detail.css);
</style>
